import axios from 'axios'
import { urls } from '../config'
import { guid, getCookie } from '../utils'

// 用户行为追踪
// 文档 http://ued.local.17173.com/wiki/pages/viewpage.action?pageId=97943554
export default function track(type, body) {
  let uid = typeof window.Passport !== 'undefined' ? window.Passport.data('uid') : ''
  if (!uid) {
    let localUid = localStorage.getItem('localUid')
    if (!localUid) {
      localUid = guid()
      localStorage.setItem('localUid', localUid)
    }
    uid = localUid
  }
  axios.post(urls.log, {
    currentUrl: window.location.href,
    uid,
    type,
    oldVid: `${window.ued.videoInfo.oldVid}`,
    body,
    csrf: getCookie('csrf'),
    timestamp: Math.round(new Date().getTime()/1000)
  })
}
